import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Card, CardBody, Button } from "@kkp/ui";
import { pageCount } from "@kkp/app-kit";
import { formatDateTime } from "@kkp/features";
import { listAccessAlerts } from "../../api/fds";

const PAGE_SIZE = 20;

export function AccessAlertsSection() {
  const [offset, setOffset] = React.useState(0);

  const { data, isLoading, isError } = useQuery({
    queryKey: ["fds-access-alerts", offset],
    queryFn: () => listAccessAlerts(PAGE_SIZE, offset),
    refetchOnMount: "always",
  });

  const items = data?.items ?? [];
  const total = BigInt(data?.total ?? 0);
  const page = Math.floor(offset / PAGE_SIZE) + 1;
  const totalPages = pageCount(total, PAGE_SIZE);

  return (
    <Card className="overflow-hidden p-0">
      <div className="flex flex-col gap-1 border-b border-[color:var(--kkp-border)] px-4 py-3">
        <div className="text-sm font-semibold text-white">Peringatan akses</div>
        <div className="text-xs text-[color:var(--kkp-text-muted)]">
          Login PIC dari negara berbeda dari sebelumnya. Informasi saja — tidak
          ada tindakan atau penahanan.
        </div>
      </div>
      <CardBody>
        {isError ? (
          <div className="text-sm text-[color:var(--kkp-text-muted)]">
            Gagal memuat peringatan akses.
          </div>
        ) : null}
        {isLoading ? (
          <div className="text-sm text-[color:var(--kkp-text-muted)]">
            Memuat…
          </div>
        ) : null}

        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="border-b border-[color:var(--kkp-border)] text-left text-xs text-[color:var(--kkp-text-muted)]">
                <th className="py-2 pr-3">Waktu</th>
                <th className="py-2 pr-3">Perusahaan</th>
                <th className="py-2 pr-3">PIC</th>
                <th className="py-2 pr-3">Negara</th>
                <th className="py-2 pr-3">IP</th>
              </tr>
            </thead>
            <tbody>
              {items.map((a) => (
                <tr
                  key={a.id}
                  className="border-b border-[color:var(--kkp-border)] text-sm text-[color:var(--kkp-text)]"
                >
                  <td className="py-2 pr-3">{formatDateTime(a.createdAt)}</td>
                  <td className="py-2 pr-3">{a.companyName ?? "—"}</td>
                  <td className="py-2 pr-3">{a.picEmail}</td>
                  <td className="py-2 pr-3">
                    {a.previousCountry} → {a.country}
                  </td>
                  <td className="py-2 pr-3">{a.ip}</td>
                </tr>
              ))}
              {!isLoading && items.length === 0 ? (
                <tr>
                  <td
                    colSpan={5}
                    className="py-3 text-center text-sm text-[color:var(--kkp-text-muted)]"
                  >
                    Tidak ada peringatan akses.
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>

        <div className="flex items-center justify-between pt-2 text-xs text-[color:var(--kkp-text-muted)]">
          <span>
            Halaman {page} / {String(totalPages)} · {String(total)} peringatan
          </span>
          <div className="flex gap-2">
            <Button
              size="sm"
              variant="secondary"
              disabled={offset === 0}
              onClick={() => setOffset((o) => Math.max(0, o - PAGE_SIZE))}
            >
              Sebelumnya
            </Button>
            <Button
              size="sm"
              variant="secondary"
              disabled={BigInt(offset + PAGE_SIZE) >= total}
              onClick={() => setOffset((o) => o + PAGE_SIZE)}
            >
              Berikutnya
            </Button>
          </div>
        </div>
      </CardBody>
    </Card>
  );
}
